export default function statusCnae(status) {
  const { concomitante, impedido } = status;
  if (concomitante) return 'Ambiguo';

  if (impedido) {
    return 'Impeditivo'
  } else {
    return 'Permitido'
  }
}
